import { useParams, useNavigate } from "react-router-dom";
import "./css/SigningFlow.css";

export default function WaiverError({
    flowContext,
    loading,
    initializationError,
    setInitializationError,
}) {

    const navigate = useNavigate();

    const {
        businessLocationSlug,
        businessTypeSlug,
        guardianToken,
    } = useParams();

    const goToServices = () => {

        if (loading) return;

        setInitializationError("");

        navigate(
            `/start-waiver/${businessLocationSlug}/${businessTypeSlug}`
        );
    };

    const isGuardianFlow = Boolean(guardianToken);

    const isLinkExpired =
    initializationError?.toLowerCase().includes("link expired");

    return (
        <div className={`page ${loading ? "page-loading" : ""}`}>

            {loading && (
                <div className="loading-overlay">
                    Loading...
                </div>
            )}

            <div className="page-header">

                <h2 className="business-name">
                    {flowContext.selectedService?.name
                        ? `${flowContext.selectedService.name} at ${flowContext.business?.businessName}`
                        : flowContext.business?.businessName}
                </h2>

            </div>

            <div className="page-content">

                <div className="error-page">

                    <div className="error-icon">
                        !
                    </div>

                    <h3 className="form-title">
                        Unable to Continue
                    </h3>

                    <div className="error-message">
                        {initializationError || "Something went wrong. Please try again."}
                    </div>

                    <p className="error-description">
                        {isLinkExpired
                            ? "This waiver link has expired and can no longer be used. Please request a new link from the minor."
                            : "We were unable to continue with this waiver. Please check the message above or contact the business for assistance."
                        }
                    </p>

                </div>

            </div>

            <div className="page-footer">

                {!isGuardianFlow && (
                    <button
                        className="primary-button"
                        type="button"
                        onClick={goToServices}
                        disabled={loading}
                    >
                        Go To Services
                        <span className="button-arrow">›</span>
                    </button>
                )}

                <div className="powered-by">
                    Powered by <strong>DidYouSign</strong>
                </div>

            </div>

        </div>
    );
}